<template>
    <div class="loginbg" id="login-main-hr">
        <div class="container">
            <div class="row">
                <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                    <div class="loginform">
                        <div class="loginlogo">
                            <img src="static/images/login-logo.png" alt="Velocity Vehicle Group">
                        </div>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Username</label>
                                <input v-model="username" type="text" name="username" class="form-control" id="username_login" placeholder="Enter Username">
                                <span class="help is-danger">{{username_error_msg}}</span>
                            </div>

                            <div class="form-group">
                                <label for="exampleInputPassword1">Password</label>
                                <input v-model="password" type="password" name="password" class="form-control" id="password_login" placeholder="Enter password">
                                <span class="help is-danger">{{password_error_msg}}</span>
                            </div>
                            <!-- <div class="form-check not-registered">
                                <a :href="not_registered_url" target="_blank">Not Registered?</a>
                            </div> -->
                            <div>
                                <button :disabled="disableButtons.loginButton" id="loginbtn" type="submit" class="btn btn-primary" v-on:click.prevent="login(this)">{{buttonNames.loginButton}}</button>
                                <!-- <a :href="forgot_pass_url" target="_blank">Forgot password?</a>  -->
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from 'vue';
    import {HTTP} from '../../http-common';
    import EventBus from '.././event-bus';
    var self;

    export default {
        name: 'Login',
        data() {
            return {
                username: "",
                password: "",
                not_registered_url: "",
                forgot_pass_url: "",
                username_error_msg: "",
                password_error_msg: "",

                forgot_pass_url: "",

                buttonNames : {
                    loginButton : 'Login',
                },

                disableButtons : {
                    loginButton : false,
                },
            }
        },
        created: function () {

        },
        beforeMount: function () {
            self = this;
        },
        mounted: function () {
            self.checkLocalStorage();
        },
        methods: {
            login: function() {
                
                var error = false;
                self.username_error_msg = '';
                self.password_error_msg = '';

                if(!self.username || self.username == null || self.username == "") {
                    self.username_error_msg = "The username field is required.";
                    error = true;
                }

                if(!self.password || self.password == null || self.password == "") {
                    self.password_error_msg = "The password field is required.";
                    error = true;
                }

                if(!error) {

                    self.buttonNames.loginButton = "Login...";
                    self.disableButtons.loginButton = true;
                    /*$('#loginbtn').text("Login...");
                    $("#loginbtn").attr("disabled", true);*/

                    var fields = {
                        email: self.username,
                        password: self.password
                    };

                    HTTP.post("login", fields)
                        .then(function (data) {

                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/

                            if (data.status == 200) {

                                localStorage.setItem("api_token", data.data.content.api_token);
                                localStorage.setItem("user_obj", JSON.stringify(data.data.user_obj));
                                window.location.href = "/dashboard";
                            }
                        })
                        .catch(function (error) {
                            self.error_msg_login = "";
                            self.buttonNames.loginButton = "Login";
                            self.disableButtons.loginButton = false;
                            /*$('#loginbtn').text("Login");
                            $("#loginbtn").attr("disabled", false);*/
                            if (error.response.status == 0) {
                                self.error_msg_login = "Remote server can not be reachable";
                            } else {
                                if (error.response.data.message) {
                                    self.error_msg_login = error.response.data.message;
                                }
                            }
                        })

                }
            },
            checkLocalStorage : function () {       
                if(localStorage.getItem('user_obj')) {
                    var userObj = localStorage.getItem('user_obj');
                    if (userObj != null && userObj !== "") {
                        self.$router.push('/dashboard');
                        // self.showHeader = true;
                        // alert("Hello");
                    } else {
                        self.$router.push('/');
                    }
                } else {
                    self.forgot_pass_url = process.env.HR_URL + "?identify=" + window.location.href;
                    self.not_registered_url = process.env.NOT_REGISTERED_HR_URL + "?identify=" + window.location.href;
                    $('#main-header').hide();
                    $('#sidebar-wrapper').hide();
                    $("#wrapper").addClass("login-div-full");
                    
                    $(".loginbg").show();
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Login/Login.vue